/** Склейка классов без зависимостей: `cn('a', cond && 'b', undefined)`. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
